import React from "react";
import { Breadcrumb, Typography } from "@arco-design/web-react";
import { useNavigate } from "react-router-dom";

const { Text } = Typography;

// MUI Breadcrumbs/Link/Typography -> Arco Breadcrumb. The MUI Link (color
// primary) becomes a clickable Breadcrumb.Item styled in the primary color;
// non-link elements render as plain text.
export default function SimpleBreadcrumbs({ elements = [] }) {
  let history = useNavigate();

  return (
    <Breadcrumb separator="›">
      <Breadcrumb.Item
        style={{ cursor: "pointer", color: "rgb(var(--arcoblue-6))" }}
        onClick={() => {
          history("/");
        }}
      >
        Home
      </Breadcrumb.Item>
      {elements.map((element) => {
        if (!element.path) {
          return (
            <Breadcrumb.Item key={element.name}>
              <Text>{element.name}</Text>
            </Breadcrumb.Item>
          );
        } else {
          return (
            <Breadcrumb.Item
              key={element.name}
              style={{ cursor: "pointer", color: "rgb(var(--arcoblue-6))" }}
              onClick={() => {
                history(element.path);
              }}
            >
              {element.name}
            </Breadcrumb.Item>
          );
        }
      })}
    </Breadcrumb>
  );
}
